/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateEventRequest
 */
export interface UpdateEventRequest {
    /**
     * Must not be greater than 255 characters.
     * @type {string}
     * @memberof UpdateEventRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventRequest
     */
    type?: string;
    /**
     * Must be a valid date.
     * @type {string}
     * @memberof UpdateEventRequest
     */
    startsAt?: string;
    /**
     * Must be a valid date. Must be a date after or equal to <code>starts_at</code>.
     * @type {string}
     * @memberof UpdateEventRequest
     */
    endsAt?: string | null;
    /**
     * Must not be greater than 255 characters.
     * @type {string}
     * @memberof UpdateEventRequest
     */
    locationName?: string;
    /**
     * Must not be greater than 255 characters.
     * @type {string}
     * @memberof UpdateEventRequest
     */
    city?: string | null;
    /**
     * Must not be greater than 255 characters.
     * @type {string}
     * @memberof UpdateEventRequest
     */
    country?: string | null;
    /**
     * Must be between -90 and 90.
     * @type {number}
     * @memberof UpdateEventRequest
     */
    lat?: number | null;
    /**
     * Must be between -180 and 180.
     * @type {number}
     * @memberof UpdateEventRequest
     */
    lng?: number | null;
    /**
     * Must be at least 1.
     * @type {number}
     * @memberof UpdateEventRequest
     */
    maxParticipants?: number | null;
}

/**
 * Check if a given object implements the UpdateEventRequest interface.
 */
export function instanceOfUpdateEventRequest(value: object): value is UpdateEventRequest {
    return true;
}

export function UpdateEventRequestFromJSON(json: any): UpdateEventRequest {
    return UpdateEventRequestFromJSONTyped(json, false);
}

export function UpdateEventRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEventRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'type': json['type'] == null ? undefined : json['type'],
        'startsAt': json['starts_at'] == null ? undefined : json['starts_at'],
        'endsAt': json['ends_at'] == null ? undefined : json['ends_at'],
        'locationName': json['location_name'] == null ? undefined : json['location_name'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'maxParticipants': json['max_participants'] == null ? undefined : json['max_participants'],
    };
}

export function UpdateEventRequestToJSON(json: any): UpdateEventRequest {
    return UpdateEventRequestToJSONTyped(json, false);
}

export function UpdateEventRequestToJSONTyped(value?: UpdateEventRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'type': value['type'],
        'starts_at': value['startsAt'],
        'ends_at': value['endsAt'],
        'location_name': value['locationName'],
        'city': value['city'],
        'country': value['country'],
        'lat': value['lat'],
        'lng': value['lng'],
        'max_participants': value['maxParticipants'],
    };
}

